export default {
	id: 'SIMPLE_PAYWALL_1M_39_1W_12',
	providers: {
		paltaMap: {
			USD: 'simple_premium_1m_39_1w_12_usd',
			EUR: 'simple_premium_1m_39_1w_12_eur',
		},
		primer: 'prd_WwNxXquRRuoO',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 1,
		intro_period_type: 'week',
		next_period_value: 1,
		next_period_type: 'month',
	},
	trial: {
		days: 7,
		priceMap: {
			USD: 12,
			EUR: 12,
		},
		originalPriceMap: {
			USD: 12,
			EUR: 12,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 39,
			EUR: 39,
		},
	},
	options: ($t, product, $tc) => ({
		explicitTermsPeriodText: $t('pages.program.organic.cheap_and_short.plans.7_days.into_period_text'), // 'first week'
		explicitTermsIntervalText: $tc('common.duration.month.base', 1), // 'month'
		billingSubtitlePeriodText: $t('pages.program.cheap_and_short.plans.7_days.into_period_text'), // 'first week'
		footerPeriodText: $t('pages.program.cheap_and_short.plans.7_days.period_text'), // '1-week'
		footerIntervalText: $t('pages.program.cheap_and_short.plans.7_days.sub_period_text'), // 'monthly'
	}),
}
